import React from 'react';

import { arrayOf, bool, node, oneOfType, shape, string } from 'prop-types';

import ClassNames from 'classnames';

import BaseComponent from '../../.internal/BaseComponent';
import LoadingSpinner from '../loading_spinner/LoadingSpinner';

import './TabContent.scss';

/**
 * @deprecated
 */
export default class TabContent extends BaseComponent {
  render() {
    const { children, style, id, className, loading } = this.props;

    const classNames = ClassNames(['TabContent', className]);

    return (
      <div className={classNames} style={style} id={id}>
        {loading ? (
          <div className="loading-spinner-container">
            <LoadingSpinner
              size="small"
              color="primary"
              className="tab-content-loading-spinner"
            />
          </div>
        ) : (
          children
        )}
      </div>
    );
  }
}

TabContent.propTypes = {
  children: oneOfType([arrayOf(node), node]),
  className: string,
  id: string,
  loading: bool,
  style: shape({}),
  title: string
};

TabContent.defaultProps = {
  children: undefined,
  className: undefined,
  id: undefined,
  loading: false,
  style: {},
  title: null
};
